import { useLayoutEffect } from "react";
import ClientReportDashboard from "./ClientReportDashboard";
import { useAppContext } from "../../Context";

const ClientReportManagementPage = props => {
    const appContext = useAppContext();

    useLayoutEffect(() => {
        appContext.setFullScreen(false);
    }, []);

    return (<>
        <div className="tw-px-xl tw-py-xl">
				 <div className="tw-pb-5">
                        <h2 className="tw-text-lg tw-font-semibold tw-leading-6 tw-text-gray-900">Client Report Management</h2>
                </div>

                <ClientReportDashboard />

        </div>
    </>);
}

export default ClientReportManagementPage;